/* global Messenger */
import { useMutation } from '@tanstack/react-query';
import { apiClient } from '../apiClient';
import { queryClient, getQueryKeyBase, MUTATION_KEYS } from '../queryClient';
import { updateCacheArray, CACHE_ACTIONS } from '../cacheClient';
import { getQueryKey as getQueryKeyCriterias } from './useCriterias';
import { getQueryKey as getQueryKeyCriteriaById } from './useGetCriteriaById';

// Config
import { crudConfig } from '../../../conf/predicate';

// Hooks
import { useCriteriaStoreUpdatePredicate } from '../../state/criteria/hooks/useCriteriaStoreUpdatePredicate';
import { usePredicateStoreUpdatePredicate } from '../../state/predicate/hooks/usePredicateStoreUpdatePredicate';
import { usePredicateStoreInit } from '../../state/predicate/hooks/usePredicateStoreInit';

export const getMutationKey = getQueryKeyBase.bind(null, MUTATION_KEYS.CRITERIA_PREDICATE);

export const useSavePredicate = ({ sessionToken, criteriaId, onSuccessCb, onErrorCb, onSettledCb }) => {
    const Client = apiClient(crudConfig);
    const updateCriteriaStorePredicate = useCriteriaStoreUpdatePredicate();
    const updatePredicateStorePredicate = usePredicateStoreUpdatePredicate();
    const reInit = usePredicateStoreInit();

    return useMutation({
        mutationKey: getMutationKey(),
        mutationFn: ({ update }) => {
            return Client.update(sessionToken, update.predicateId, update);
        },
        onSuccess: (data, variables) => {
            reInit(data);
            Messenger.showMessage({
                type: `success`,
                title: `Predicate has been successfully updated.`
            });
            updateCriteriaStorePredicate(data);
            updatePredicateStorePredicate(data);
            // updateCacheSingle({
            //     queryKey: getQueryKeyCriteriaById(criteriaId),
            //     action: CACHE_ACTIONS.UPDATE,
            //     primaryKey: crudConfig.primaryKey,
            //     data
            // });
            queryClient.invalidateQueries({
                queryKey: getQueryKeyCriteriaById(criteriaId),
                refetchType: 'inactive'
            });
            onSuccessCb?.({
                context: variables?.context
            });
        },
        onError: (error) => {
            console.log('Error', error);
            onErrorCb?.(error);
        },
        onSettled: () => {
            onSettledCb?.();
        },
        refetchOnWindowFocus: false
    });
};
